export default __webpack_public_path__ + "static/media/sv_14.b5f01ab9.webp";